import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../features/auth/authSlice'
import { getdomainName } from '../api/axios'

const Footer = () => {
  const user = useSelector(selectCurrentUser)
  // console.log(user);
  return (
    <footer className="bg-white border-t mt-2 py-4 text-center text-gray-600 text-sm">
      &copy; 2026 {user?.UserData?.name || getdomainName()}. All rights reserved.
    </footer>
  )
}

export default Footer